import { render } from "./recommendArticle.vue?vue&type=template&id=205da661&scoped=true"
import script from "./recommendArticle.vue?vue&type=script&lang=js"
export * from "./recommendArticle.vue?vue&type=script&lang=js"

import "./recommendArticle.vue?vue&type=style&index=0&id=205da661&lang=less&scoped=true"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205da661"]])

export default __exports__